// src/archiveCantine.js
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

gsap.registerPlugin(ScrollTrigger);

export function initArchiveCantine() {
  const slider = document.querySelector('.cantine-slider');
  if (!slider) {
    //console.log('Archive cantine: slider non trovato, uscita anticipata');
    return;
  }
  const slides = slider.querySelectorAll('.cantine-slide');
  slider.style.setProperty('--slide-n', slides.length);
  slider.style.setProperty('--slides-count', slides.length);
  
  for (let i = 0; i < slides.length; i++) {
      slides[i].style.zIndex = slides.length - i;
      
      // Ottimizzazione per le immagini di background
      const bgOverlay = slides[i].querySelector('.slide-bg-overlay');
      if (bgOverlay) {
        bgOverlay.style.willChange = 'transform';
        bgOverlay.style.backfaceVisibility = 'hidden';
        bgOverlay.style.transform = 'translateY(0px)';
      }
      
      // Ottimizzazione per il testo delle slide
      const slideText = slides[i].querySelector('.slide-text');
      // if (slideText) {
      //   slideText.style.willChange = 'transform';
      //   slideText.style.backfaceVisibility = 'hidden';
      //   slideText.style.transform = 'translateY(0px)';
      // }
      // slides[i].style.backgroundColor = `hsl(${Math.random() * 360}, 70%, 50%)`;
  }

  let progress = 0;
  let ticking = true;

  function renderScroll(){
    if (ticking) {
      window.requestAnimationFrame(() => {
        const sliderTop = slider.offsetTop;
        const sliderHeight = slider.offsetHeight;
        const viewportHeight = window.innerHeight;

        // La distanza totale che si può scorrere mentre l'effetto slider è attivo
        const scrollableDistance = sliderHeight - viewportHeight;

        // Evita la divisione per zero se il contenitore non è scrollabile
        if (scrollableDistance <= 0) {
          ticking = true; // Resetta il flag e esci
          return;
        }

        // Calcola quanto abbiamo scrollato dall'inizio del contenitore slider
        const scrolledFromTop = window.scrollY - sliderTop;

        // Calcola la progressione, limitandola tra 0 e 1
        progress = Math.max(0, Math.min(1, scrolledFromTop / scrollableDistance));

        renderSlider(sliderHeight,scrolledFromTop, viewportHeight);
        ticking = true; // Resetta il flag per permettere la prossima esecuzione
        renderScroll();
      });
      ticking = true; // Imposta il flag per evitare di schedulare altri frame
    }

  }

  renderScroll();

  window.addEventListener('scroll', () => {

  });

  function renderSlider(sliderHeight,scrolledFromTop, viewportHeight) {
    const nSlideTarget = Math.floor(scrolledFromTop / viewportHeight);
    
    for (let i = 0; i < slides.length-1; i++) {
      const slide = slides[i];
      const bgOverlay = slide.querySelector('.slide-bg-overlay');
      const slideText = slide.querySelector('.slide-text');
      
      // Calcola la posizione relativa di questa slide rispetto allo scroll
      const slideStartPosition = i * viewportHeight;
      const slideEndPosition = (i + 1) * viewportHeight;
      const slideProgress = Math.max(0, Math.min(1, (scrolledFromTop - slideStartPosition) / viewportHeight));
      
      // Applica il parallax basato sulla posizione della slide nello scroll
      // if (bgOverlay) {
      //   // Parallax che funziona durante tutto lo scroll della slide
      //   const parallaxOffset = slideProgress * 60; // 60px di movimento massimo per slide
      //   bgOverlay.style.transform = `translateY(-${parallaxOffset}px)`;
      // }
      
      // Applica lo stesso movimento parallax al testo
      // if (slideText) {
      //   const textParallaxOffset = slideProgress * 60; // Stesso movimento delle immagini
      //   slideText.style.transform = `translateY(-${textParallaxOffset}px)`;
      // }
      
      if (i < nSlideTarget) {
        slide.style.clipPath = 'inset( 0 0 100% 0)';
      } else if (i === nSlideTarget) {
        // La slide attiva viene tagliata dal basso in base allo scroll.
        const clipAmount = scrolledFromTop % viewportHeight;
        slide.style.clipPath = `inset( 0 0 ${clipAmount}px 0)`;
      } else {
        // Le slide future non sono tagliate.
        slide.style.clipPath = 'inset(0 0 0 0)';
      }
    }
  }

  // Inizializza lo slider mobile per i loghi
  initArchiveCantineLogosSlider();
}

let archiveCantineLogosSwiperInstance = null;

function initArchiveCantineLogosSlider() {
  const sliderEl = document.querySelector('.arch_cant-logos-swiper');
  if (!sliderEl) return;

  // Inizializza solo su mobile (<= 1024px)
  if (window.innerWidth > 1024) {
    // Se siamo su desktop, distruggi lo slider se esiste
    if (archiveCantineLogosSwiperInstance) {
      archiveCantineLogosSwiperInstance.destroy(true, true);
      archiveCantineLogosSwiperInstance = null;
    }
    return;
  }

  const slides = sliderEl.querySelectorAll('.swiper-slide');
  if (!slides.length) return;

  // Se lo slider esiste già, distruggilo prima di ricrearlo
  if (archiveCantineLogosSwiperInstance) {
    archiveCantineLogosSwiperInstance.destroy(true, true);
    archiveCantineLogosSwiperInstance = null;
  }

  const paginationEl = sliderEl.querySelector('.swiper-pagination');

  const swiperConfig = {
    modules: [Pagination],
    slidesPerView: 2.6,
    spaceBetween: 0,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    pagination: {
      el: '.arch_cant-logos-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
  };

  archiveCantineLogosSwiperInstance = new Swiper(sliderEl, swiperConfig);

  // Gestisci il resize per distruggere/ricreare lo slider
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initArchiveCantineLogosSlider();
    }, 250);
  };

  // Aggiungi listener resize solo una volta
  if (!window.archiveCantineLogosResizeHandler) {
    window.archiveCantineLogosResizeHandler = handleResize;
    window.addEventListener('resize', handleResize);
  }
}